import {
	grayColor,
	roseColor,
	infoColor,
	successColor,
	warningColor,
	dangerColor,
	whiteColor,
	twitterColor,
	facebookColor,
	googleColor,
	linkedinColor,
	pinterestColor,
	youtubeColor,
	tumblrColor,
	behanceColor,
	dribbbleColor,
	redditColor,
	hexToRgb,
	blackColor,
	blackColors,
	menuHoverBgColor,
	support1Color,
	iconHoverFilter,
	formButtons,
	formElementColors,
} from 'assets/jss/material-dashboard-pro-react';
import { darken } from '@material-ui/core/styles';

const buttonStyle = (theme) => ({
	button: {
		fontFamily: theme.fontFamily.alvar.bold,
		fontWeight: 'normal',
		height: '40px',
		minWidth: '48px',
		backgroundColor: grayColor[0],
		color: whiteColor,
		boxShadow: 'none',
		border: 'none',
		borderRadius: '4px',
		boxSizing: 'border-box',
		position: 'relative',
		padding: '12px 8px',
		margin: '.3125rem 1px',
		fontSize: theme.fontSize(16),
		textTransform: 'none',
		letterSpacing: 'normal',
		willChange: 'transform',
		transition: 'background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
		lineHeight: '1.14',
		textAlign: 'center',
		whiteSpace: 'nowrap',
		verticalAlign: 'middle',
		touchAction: 'manipulation',
		cursor: 'pointer',
		'&:hover, &:focus': {
			color: whiteColor,
			backgroundColor: grayColor[0],
			boxShadow: 'none',
		},
		'& .fab,& .fas,& .far,& .fal,& .material-icons': {
			position: 'relative',
			display: 'inline-block',
			top: '0',
			marginTop: '-1em',
			marginBottom: '-1em',
			fontSize: '1.1rem',
			marginRight: '4px',
			verticalAlign: 'middle',
		},
		'& svg': {
			position: 'relative',
			display: 'inline-block',
			top: '0',
			width: '18px',
			height: '18px',
			marginRight: '8px',
			verticalAlign: 'middle',
		},
		'&$justIcon': {
			'& .fab,& .fas,& .far,& .fal,& .material-icons': {
				marginTop: '0px',
				position: 'absolute',
				width: '100%',
				transform: 'none',
				left: '0px',
				top: '0px',
				height: '100%',
				lineHeight: '41px',
				fontSize: '20px',
			},
		},
	},
	fullWidth: {
		width: '100%',
	},
	noMargin: {
		margin: 0,
	},
	'primary-light': {
		'&': {
			backgroundColor: theme.palette.primary.main,
		},
		'&:focus, &:hover': {
			backgroundColor: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.88)`,
		},
		'&:active, &:active&:hover': {
			backgroundColor: darken(theme.palette.primary.main, 0.12),
		},
		'&:disabled, &:disabled&:hover': {
			backgroundColor: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.38)`,
			color: whiteColor,
		},
	},
	'primary-light-v2': {
		'&': {
			fontFamily: theme.fontFamily.albert.regular,
			backgroundColor: formButtons[0],
			borderRadius: '1rem',
			padding: '15px 22px',
		},
		'&:focus, &:hover': {
			backgroundColor: formButtons[1],
		},
		'&:active, &:active&:hover': {
			backgroundColor: formButtons[2],
		},
		'&:disabled, &:disabled&:hover': {
			backgroundColor: formButtons[3],
			color: formElementColors.label,
		},
	},
	'primary-dark': {
		'&': {
			backgroundColor: whiteColor,
		},
		'&, &:focus, &:hover, &:active': {
			color: theme.palette.primary.main,
		},
		'&:focus, &:hover': {
			backgroundColor: `rgba(${hexToRgb(whiteColor)}, 0.94)`,
		},
		'&:active, &:active&:hover': {
			backgroundColor: `rgba(${hexToRgb(whiteColor)}, 0.88)`,
		},
		'&:disabled, &:disabled&:hover': {
			backgroundColor: `rgba(${hexToRgb(whiteColor)}, 0.24)`,
			color: `rgba(${hexToRgb(whiteColor)}, 0.5)`,
		},
	},
	'primary-dark-v2': {
		'&': {
			fontFamily: theme.fontFamily.albert.regular,
			fontSize: theme.fontSize(14),
			color: blackColors[0],
			backgroundColor: 'transparent',
		},
		'&:focus, &:hover, &:active, &:active&:hover': {
			color: support1Color[0],
			backgroundColor: menuHoverBgColor,
			borderRadius: '1rem',
			'& img': {
				filter: iconHoverFilter,
			},
		},
		'&:disabled, &:disabled&:hover': {
			backgroundColor: 'transparent',
			color: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.38)`,
		},
	},
	'secondary-light': {
		'&': {
			backgroundColor: 'transparent',
		},
		'&, &&:hover, &:focus, &:focus&:hover, &:active, &:active&:hover': {
			border: `solid 1.5px ${theme.palette.primary.main}`,
			color: theme.palette.primary.main,
		},
		'&:focus, &:hover': {
			backgroundColor: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.2)`,
		},
		'&:active, &:active&:hover': {
			backgroundColor: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.30)`,
		},
		'&:disabled, &:disabled&:hover': {
			backgroundColor: 'transparent',
			color: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.38)`,
			border: `solid 1.5px rgba(${hexToRgb(theme.palette.primary.main)}, 0.38)`,
		},
	},
	'secondary-dark': {
		'&': {
			backgroundColor: 'transparent',
		},
		'&:disabled, &:disabled&:hover': {
			backgroundColor: 'transparent',
			border: `solid 1.5px rgba(${hexToRgb(whiteColor)}, 0.24)`,
			color: `rgba(${hexToRgb(whiteColor)}, 0.5)`,
		},
		'&:focus, &:hover': {
			backgroundColor: `rgba(${hexToRgb(whiteColor)}, 0.15)`,
		},
		'&:active, &:active&:hover': {
			backgroundColor: `rgba(${hexToRgb(whiteColor)}, 0.3)`,
		},
		'&, &&:hover, &:focus, &:focus&:hover, &:active, &:active&:hover': {
			border: `solid 1.5px ${whiteColor}`,
			color: whiteColor,
		},
	},
	'tertiary-light': {
		'&': {
			color: theme.palette.primary.main,
			backgroundColor: 'transparent',
		},
		'&:focus, &:hover': {
			color: theme.palette.primary.main,
			backgroundColor: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.2)`,
		},
		'&:active, &:active&:hover': {
			color: theme.palette.primary.main,
			backgroundColor: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.3)`,
		},
		'&:disabled, &:disabled&:hover': {
			backgroundColor: 'transparent',
			color: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.38)`,
		},
	},
	'tertiary-light-v2': {
		'&': {
			fontFamily: theme.fontFamily.albert.regular,
			backgroundColor: whiteColor,
			borderRadius: '1rem',
			padding: '15px 22px',
			color: formButtons[0],
			border: `1px solid ${formButtons[0]}`,
		},
		'&:focus, &:hover': {
			color: theme.palette.primary.main,
			backgroundColor: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.2)`,
		},
		'&:active, &:active&:hover': {
			color: theme.palette.primary.main,
			backgroundColor: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.3)`,
		},
		'&:disabled, &:disabled&:hover': {
			backgroundColor: 'transparent',
			color: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.38)`,
		},
	},
	'tertiary-dark': {
		'&': {
			backgroundColor: 'transparent',
		},
		'&:focus, &:hover': {
			backgroundColor: `rgba(${hexToRgb(whiteColor)}, 0.15)`,
		},
		'&:active, &:active&:hover': {
			backgroundColor: `rgba(${hexToRgb(whiteColor)}, 0.3)`,
		},
		'&:disabled, &:hover&:disabled': {
			backgroundColor: 'transparent',
			color: `rgba(${hexToRgb(whiteColor)}, 0.5)`,
		},
	},
	'tertiary-danger': {
		'&': {
			color: dangerColor[0],
			backgroundColor: 'transparent',
		},
		'&:focus, &:hover': {
			backgroundColor: 'transparent',
			color: dangerColor[0],
		},
		'&:active, &:active&:hover': {
			backgroundColor: 'transparent',
			color: dangerColor[0],
		},
		'&:disabled, &:hover&:disabled': {
			backgroundColor: 'transparent',
			color: `rgba(${hexToRgb(dangerColor[0])}, 0.5)`,
		},
	},
	'tertiary-gray': {
		'&': {
			color: blackColor[3],
			backgroundColor: 'transparent',
		},
		'&:focus, &:hover': {
			backgroundColor: 'transparent',
			color: blackColor[3],
		},
		'&:active, &:active&:hover': {
			backgroundColor: 'transparent',
			color: blackColor[3],
		},
		'&:disabled, &:hover&:disabled': {
			backgroundColor: 'transparent',
			color: blackColor[3],
		},
	},
	primary: {
		backgroundColor: theme.palette.primary.main,
		'&:hover,&:focus': {
			backgroundColor: theme.palette.primary.main,
		},
	},
	info: {
		backgroundColor: infoColor[0],
		'&:hover,&:focus': {
			backgroundColor: infoColor[0],
		},
	},
	success: {
		backgroundColor: successColor[0],
		'&:hover,&:focus': {
			backgroundColor: successColor[0],
		},
	},
	warning: {
		backgroundColor: warningColor[0],
		'&:hover,&:focus': {
			backgroundColor: warningColor[0],
		},
	},
	danger: {
		backgroundColor: dangerColor[0],
		'&:hover,&:focus': {
			backgroundColor: dangerColor[0],
		},
	},
	rose: {
		backgroundColor: roseColor[0],
		'&:hover,&:focus': {
			backgroundColor: roseColor[0],
		},
	},
	white: {
		'&,&:focus,&:hover': {
			backgroundColor: whiteColor,
			color: grayColor[0],
		},
	},
	twitter: {
		backgroundColor: twitterColor,
		color: whiteColor,
		'&:hover,&:focus,&:visited': {
			backgroundColor: twitterColor,
			color: whiteColor,
		},
	},
	facebook: {
		backgroundColor: facebookColor,
		color: whiteColor,
		'&:hover,&:focus': {
			backgroundColor: facebookColor,
			color: whiteColor,
		},
	},
	google: {
		backgroundColor: googleColor,
		color: whiteColor,
		'&:hover,&:focus': {
			backgroundColor: googleColor,
			color: whiteColor,
		},
	},
	linkedin: {
		backgroundColor: linkedinColor,
		color: whiteColor,
		'&:hover,&:focus': {
			backgroundColor: linkedinColor,
			color: whiteColor,
		},
	},
	pinterest: {
		backgroundColor: pinterestColor,
		color: whiteColor,
		'&:hover,&:focus': {
			backgroundColor: pinterestColor,
			color: whiteColor,
		},
	},
	youtube: {
		backgroundColor: youtubeColor,
		color: whiteColor,
		'&:hover,&:focus': {
			backgroundColor: youtubeColor,
			color: whiteColor,
		},
	},
	tumblr: {
		backgroundColor: tumblrColor,
		color: whiteColor,
		'&:hover,&:focus': {
			backgroundColor: tumblrColor,
			color: whiteColor,
		},
	},
	github: {
		backgroundColor: grayColor[7],
		color: whiteColor,
		'&:hover,&:focus': {
			backgroundColor: grayColor[7],
			color: whiteColor,
		},
	},
	behance: {
		backgroundColor: behanceColor,
		color: whiteColor,
		'&:hover,&:focus': {
			backgroundColor: behanceColor,
			color: whiteColor,
		},
	},
	dribbble: {
		backgroundColor: dribbbleColor,
		color: whiteColor,
		'&:hover,&:focus': {
			backgroundColor: dribbbleColor,
			color: whiteColor,
		},
	},
	reddit: {
		backgroundColor: redditColor,
		color: whiteColor,
		'&:hover,&:focus': {
			backgroundColor: redditColor,
			color: whiteColor,
		},
	},
	simple: {
		'&,&:focus,&:hover': {
			color: whiteColor,
			background: 'transparent',
			boxShadow: 'none',
		},
		'&$primary': {
			'&,&:focus,&:hover,&:visited': {
				color: theme.palette.primary.main,
			},
		},
		'&$info': {
			'&,&:focus,&:hover,&:visited': {
				color: infoColor[0],
			},
		},
		'&$success': {
			'&,&:focus,&:hover,&:visited': {
				color: successColor[0],
			},
		},
		'&$warning': {
			'&,&:focus,&:hover,&:visited': {
				color: warningColor[0],
			},
		},
		'&$rose': {
			'&,&:focus,&:hover,&:visited': {
				color: roseColor[0],
			},
		},
		'&$danger': {
			'&,&:focus,&:hover,&:visited': {
				color: dangerColor[0],
			},
		},
		'&$twitter': {
			'&,&:focus,&:hover,&:visited': {
				color: twitterColor,
			},
		},
		'&$facebook': {
			'&,&:focus,&:hover,&:visited': {
				color: facebookColor,
			},
		},
		'&$google': {
			'&,&:focus,&:hover,&:visited': {
				color: googleColor,
			},
		},
		'&$linkedin': {
			'&,&:focus,&:hover,&:visited': {
				color: linkedinColor,
			},
		},
		'&$pinterest': {
			'&,&:focus,&:hover,&:visited': {
				color: pinterestColor,
			},
		},
		'&$youtube': {
			'&,&:focus,&:hover,&:visited': {
				color: youtubeColor,
			},
		},
		'&$tumblr': {
			'&,&:focus,&:hover,&:visited': {
				color: tumblrColor,
			},
		},
		'&$github': {
			'&,&:focus,&:hover,&:visited': {
				color: grayColor[7],
			},
		},
		'&$behance': {
			'&,&:focus,&:hover,&:visited': {
				color: behanceColor,
			},
		},
		'&$dribbble': {
			'&,&:focus,&:hover,&:visited': {
				color: dribbbleColor,
			},
		},
		'&$reddit': {
			'&,&:focus,&:hover,&:visited': {
				color: redditColor,
			},
		},
	},
	transparent: {
		'&,&:focus,&:hover': {
			color: 'inherit',
			background: 'transparent',
			boxShadow: 'none',
		},
	},
	disabled: {
		pointerEvents: 'none',
	},
	hidden: {
		display: 'none',
	},
	lg: {
		'&$justIcon': {
			'& .fab,& .fas,& .far,& .fal,& svg,& .material-icons': {
				//marginTop: "-4px"
			},
		},
		padding: '14px 16px',
		fontSize: theme.fontSize(18),
		lineHeight: '1.11',
		borderRadius: '0.2rem',
		minWidth: '128px',
		height: '48px',
	},
	sm: {
		'&$justIcon': {
			'& .fab,& .fas,& .far,& .fal,& svg,& .material-icons': {
				marginTop: '1px',
			},
		},
		padding: '8px',
		minWidth: '72px',
		fontSize: theme.fontSize(12),
		lineHeight: '1.17',
		borderRadius: '0.2rem',
		height: '32px',
	},
	round: {
		borderRadius: '30px',
	},
	block: {
		width: '100% !important',
	},
	link: {
		'&,&:hover,&:focus': {
			backgroundColor: 'transparent',
			color: grayColor[0],
			boxShadow: 'none',
		},
	},
	justIcon: {
		paddingLeft: '12px',
		paddingRight: '12px',
		fontSize: '20px',
		height: '41px',
		minWidth: '41px',
		width: '41px',
		'& .fab,& .fas,& .far,& .fal,& svg,& .material-icons': {
			marginRight: '0px',
		},
		'&$lg': {
			height: '48px',
			minWidth: '48px',
			width: '48px',
			lineHeight: '56px',
			'& .fab,& .fas,& .far,& .fal,& .material-icons': {
				fontSize: '32px',
				lineHeight: '56px',
			},
			'& svg': {
				width: '24px',
				height: '24px',
			},
		},
		'&$sm': {
			height: '30px',
			minWidth: '30px',
			width: '30px',
			'& .fab,& .fas,& .far,& .fal,& .material-icons': {
				fontSize: '17px',
				lineHeight: '29px',
			},
			'& svg': {
				width: '17px',
				height: '17px',
			},
		},
	},
	withIcon: {
		[theme.browser.IE]: {
			'& > span:first-of-type': {
				display: 'inline-block',
			},
		},
		'& svg': {
			marginBottom: '2px',
			marginRight: '4px',
			fontSize: '12px',
			height: '16px',
			width: 'auto',
			maxWidth: '16px',
		},
	},
});

export default buttonStyle;
